import React, { useCallback, useEffect } from 'react'
import { View } from './View'
import { useRefunds, RefundListItem } from '../../../../../services/api/refunds'
import { OrderData } from '../../../../../services/api/orders'
import { AsyncStates } from '../../../../../components'

type Props = {
  order: OrderData
}

export const Container: React.FunctionComponent<Props> = ({ order }) => {
  const [getRefundsPage, { isLoading, error, response }] = useRefunds()

  const getRefund = useCallback(() => {
    getRefundsPage({
      orderId: order.id,
      page: 1,
      perPage: 1,
    })
  }, [getRefundsPage, order])

  useEffect(() => {
    getRefund()
  }, [getRefund])

  return (
    <AsyncStates<RefundListItem[]>
      isLoading={isLoading}
      error={error}
      errorMessage="Не удалось загрузить информацию по возврату"
      reload={() => getRefund()}
      response={response}
      renderData={(refunds) => refunds[0] && <View refund={refunds[0]} />}
    />
  )
}
